import dayjs from 'dayjs';
import { MasterData } from './services/master-data';

export const DUMMY_EXISTING_PLAFON = [
	{
		key: 1,
		id: 'NJF_INACTIVE_123123123123',
		active: false,
		expired: dayjs().subtract(1, 'year').toISOString(),
		orderType: {
			id: 1,
			value: 'Pengajuan Fasilitas Baru',
		} as MasterData,
		segmentMarket: {
			id: 2,
			value: 'Captive',
		} as MasterData,
		orderSource: {
			id: 2,
			value: 'Captive Non JF',
		} as MasterData,
		referrerName: 'Ari',
		referrerPosition: {
			id: 1,
			value: 'Staff',
		} as MasterData,
		referrerPhoneNumber: '0821155222133',
		applicationLimit: 10000000000000,
		plafonType: {
			id: 1,
			value: 'Non Join Financing',
		} as MasterData,
		financingTypeIds: [1] as number[],
		financingObjectIds: [1, 2] as number[],
		referrerUnit: {
			id: 2,
			value: 'KCP Sunter Paradise',
		} as MasterData,
	},
	{
		key: 2,
		id: 'JF_ACTIVE_123123123123',
		active: true,
		expired: dayjs().add(1, 'year').toISOString(),
		orderType: {
			id: 1,
			value: 'Pengajuan Fasilitas Baru',
		} as MasterData,
		segmentMarket: {
			id: 2,
			value: 'Captive',
		} as MasterData,
		orderSource: {
			id: 2,
			value: 'Captive Non JF',
		} as MasterData,
		referrerName: 'Ari',
		referrerPosition: {
			id: 1,
			value: 'Staff',
		} as MasterData,
		referrerPhoneNumber: '0821155222133',
		applicationLimit: 10000000000000,
		plafonType: {
			id: 1,
			value: 'Non Join Financing',
		} as MasterData,
		financingTypeIds: [1, 3] as number[],
		financingObjectIds: [1] as number[],
		referrerUnit: {
			id: 2,
			value: 'KCP Sunter Paradise',
		} as MasterData,
	} as const,
];
